<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                        :placeholder="$t('keyword')"></b-form-input>
          <client-select v-if="!client" :model="filterFormModel" attribute="client" @change="search" :isFilter="true"
                         :place-holder="$t('selectClient')" class="mr-1 mb-1"></client-select>
          <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="status" :options="[
                  {value: null, text: $t('selectStatus')},
                  {value: 1, text: $t('success')},
                  {value: 2, text: $t('error')},
                ]"></form-select>
          <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="type" :options="[
                        {value: null,text:$t('selectType')},
                        {value:'call', text:$t('call')},
                        {value:'callChangeFile', text:$t('callChangeFile')},
                        {value:'notification', text:$t('notification')},
                        {value:'customer', text:$t('customer')},
                        {value:'opportunity', text:$t('opportunity')},
                        {value:'task', text:$t('task')},
                        {value:'ticket', text:$t('ticket')},
                        {value:'callCampaign', text:$t('callCampaign')},
                        {value:'callCampaignContact', text:$t('callCampaignContact')},
                        {value:'messageCampaign', text:$t('messageCampaign')},
                        {value:'automation', text:$t('automation')},
                        {value:'user', text:$t('user')},
                        {value:'googleSheetSetup', text:$t('googleSheetSetup')},
                        {value:'googleSheetSetup', text:$t('googleSheet')},
                        {value:'clientKYC', text:$t('clientKYC')},
                        {value:'phoneNumber', text:$t('phoneNumber')},
                        {value:'creditTransaction', text:$t('creditTransaction')},
                        {value:'socialNetworkAccount', text:$t('socialNetworkAccount')},
                        {value:'aiAgent', text:$t('aiAgent')},
              ]"></form-select>
          <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="action" :options="[
                        {value: null,text:$t('selectAction')},
                        {value:'create',text: $t('create')},
                        {value:'update',text: $t('update')},
                        {value:'del',text: $t('delete')},
                        {value:'import',text: $t('import')},
                        {value:'export',text: $t('export')},
                        {value:'webhook',text: 'Webhook'},
              ]"></form-select>
          <time-range-picker :model="filterFormModel" :defaultShortcut="0" :label="$t('createTime')"
                             class="mr-1 mb-1"></time-range-picker>
          <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-2">{{ $t('time') }}</div>
          <div class="col-lg-4">{{ $t('content') }}</div>
          <div class="col-lg-2">{{ $t('client') }}</div>
          <div class="col-lg-2 text-center">{{ $t('status') }}</div>
          <div class="col-lg-2">{{ $t('createdBy') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-2">
            <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
          </div>
          <div class="col-lg-4">
            <div v-html="item.content.replace(/\n/g, '<br />')"></div>
            <div v-if="item.type === 'webhook'" class="c-sms-item__content active">
              <div class="mb-2"><b>Request</b> {{ item.webhook.method }} {{ item.webhook.url }}</div>
              <json-viewer theme="dark-json-viewer" v-if="item.webhook.data"
                           :value="JSON.parse(item.webhook.data)"
                           :expand-depth=1 :boxed=false sort>
              </json-viewer>
            </div>
            <div class="mt-4" v-if="item.type === 'callChangeFile'">
              <div>
                <label>{{ $t('recording') }}</label>
                <app-audio v-if="item.call && item.call.recordingDownloaded" :id="item.call._id"
                           :duration="item.call.duration" :log="item._id"/>
              </div>
              <div class="mt-2">
                <label>{{ $t('changeRecording') }}</label>
                <app-audio v-if="item.call && item.call.recordingDownloaded" :id="item.call._id"
                           :duration="item.call.duration"/>
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <span v-if="item.client">{{ item.client.domain }}</span>
            <span class="small" v-else>{{ $t('unknown') }}</span>
          </div>
          <div class="col-lg-2 text-center">
            <p>
              <label v-if="item.error" class="badge badge-danger">{{ $t('error') }}</label>
              <label v-else class="badge badge-success">{{ $t('success') }}</label>
            </p>
          </div>
          <div class="col-lg-2">
            <span v-if="item.user">{{ item.user.name }} ({{ item.user.ext }})</span>
            <span class="small" v-else>{{ $t('unknown') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>
    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import JsonViewer from 'vue-json-viewer';
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import TimeRangePicker from "../../components/TimeRangePicker";
import ClientSelect from '@/components/ClientSelect.vue'
import AppAudio from '@/components/AppAudio.vue'
import moment from 'moment'

export default {
  components: {
    AppAudio,
    ClientSelect,
    JsonViewer, TimeRangePicker
  },
  props: ['client'],
  mixins: [List, CRUD],
  data() {
    return {
      showList: false,
      service: '/client-log',
      autoLoad: true,
      defaultFilterFormModel: {
        status: null,
        type: null,
        action: null,
        client: this.client ? this.client._id : null,
        keyword: null,
        from: moment().startOf('day').valueOf(),
        to: moment().endOf('day').valueOf(),
      }
    }
  },
  i18n: {
    messages: {
      en: {
        activity: "activity",
        title: "lient activity history",
        content: "Content",
        createdBy: "Created by",
        callCampaign: "Call campaign",
        webhook: "Webhook",
        selectStatus: "Select status",
        selectType: "Select type",
        selectAction: "Select action",
        import: "Import",
        call: "Call",
        customer: "Customer",
        opportunity: "Opportunity",
        task: "Task",
        ticket: "Ticket",
        notification: "Notification",
        callCampaignContact: "Call campaign contact",
        messageCampaign: "Message campaign",
        googleSheetSetup: "Google sheet setup",
        automation: "Automation",
        clientKYC: "Profile",
        googleSheet: "Google Sheet",
        recording: "Recording file",
        changeRecording: "Alternate recording file",
        callChangeFile: "Change recording file",
        creditTransaction: "Credit transaction",
        socialNetworkAccount: "Social network account",
        aiAgent: "AI agent",
      },
      vi: {
        activity: "Hoạt động",
        title: "Lịch sử hoạt động của khách",
        content: "Nội dung",
        createdBy: "Tạo bởi",
        callCampaign: "Chiến dịch gọi",
        webhook: "Webhook",
        selectStatus: "Chọn trạng thái",
        selectType: "Chọn loại",
        selectAction: "Chọn hành động",
        import: "Tải lên",
        call: "Cuộc gọi",
        customer: "Khách hàng",
        opportunity: "Cơ hội bán hàng",
        task: "Việc cần làm",
        ticket: "Ticket",
        notification: "Thông báo",
        callCampaignContact: "Liên hệ chiến dịch gọi",
        messageCampaign: "Chiến dịch tin nhắn",
        googleSheetSetup: "Cài đặt Google sheet",
        automation: "Tự động hoá",
        clientKYC: "Hồ sơ",
        googleSheet: "Google Sheet",
        recording: "File ghi âm",
        changeRecording: "Tập tin ghi âm thay thế",
        callChangeFile: "Thay đổi file ghi âm",
        creditTransaction: "Lịch sử giao dịch",
        socialNetworkAccount: "Tài khoản mạng xã hội",
        aiAgent: "Nhân viên AI",
      }
    }
  },
  methods: {
    search() {
      this.filterFormModel.page = 1;
      this.load();
    },
    reset() {
      this.filterFormModel = Object.assign({}, this.defaultFilterFormModel);
      this.load();
    }
  }
}
</script>
<style>
.dark-json-viewer {
  background: #f8f8fb;
}
</style>
